import { apiClient } from "../axiosInstance";
import { StandardAxiosConfig } from "../common";
import { MissionControlLog } from "../../models";

export class MissionControlAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${import.meta.env.VITE_ROGO_API_URL}/mission-control`;
	}

	public async getLogs(user: string, start: string, end: string): Promise<MissionControlLog[]> {
		const url = `${this.baseUrl}/logs`;
		const response = await apiClient.get(url, {
			...StandardAxiosConfig(),
			params: { user, start, end },
		});
		return response.data as MissionControlLog[];
	}
}
